var _mask, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElipseContact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_160_360",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.49999 116C15.6677 116 30.6869 113.012 44.7 107.208C58.7132 101.404 71.4458 92.8959 82.171 82.1707C92.8961 71.4455 101.404 58.7128 107.208 44.6996C113.013 30.6865 116 15.6673 116 0.49958L63.4013 0.499769C63.4013 8.76011 61.7744 16.9396 58.6133 24.5711C55.4522 32.2027 50.8189 39.1369 44.978 44.9779C39.1371 50.8188 32.2029 55.4521 24.5713 58.6132C16.9398 61.7743 8.76033 63.4013 0.499992 63.4013L0.49999 116Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.49999 116C15.6677 116 30.6869 113.012 44.7 107.208C58.7132 101.404 71.4458 92.8959 82.171 82.1707C92.8961 71.4455 101.404 58.7128 107.208 44.6996C113.013 30.6865 116 15.6673 116 0.49958L63.4013 0.499769C63.4013 8.76011 61.7744 16.9396 58.6133 24.5711C55.4522 32.2027 50.8189 39.1369 44.978 44.9779C39.1371 50.8188 32.2029 55.4521 24.5713 58.6132C16.9398 61.7743 8.76033 63.4013 0.499992 63.4013L0.49999 116Z",
    stroke: "black",
    strokeWidth: 2,
    mask: "url(#path-1-inside-1_160_360)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElipseContact);
export default __webpack_public_path__ + "static/media/elipse_contact.99244b2abd14bc7377d7b43c5f79b68c.svg";
export { ForwardRef as ReactComponent };